/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalculationParameterEntryParam } from './CalculationParameterEntryParam';
import {
    CalculationParameterEntryParamFromJSON,
    CalculationParameterEntryParamFromJSONTyped,
    CalculationParameterEntryParamToJSON,
    CalculationParameterEntryParamToJSONTyped,
} from './CalculationParameterEntryParam';

/**
 * 
 * @export
 * @interface SaveCalculationParameterEntriesRequest
 */
export interface SaveCalculationParameterEntriesRequest {
    /**
     * 
     * @type {Array<CalculationParameterEntryParam>}
     * @memberof SaveCalculationParameterEntriesRequest
     */
    entries: Array<CalculationParameterEntryParam>;
}

/**
 * Check if a given object implements the SaveCalculationParameterEntriesRequest interface.
 */
export function instanceOfSaveCalculationParameterEntriesRequest(value: object): value is SaveCalculationParameterEntriesRequest {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function SaveCalculationParameterEntriesRequestFromJSON(json: any): SaveCalculationParameterEntriesRequest {
    return SaveCalculationParameterEntriesRequestFromJSONTyped(json, false);
}

export function SaveCalculationParameterEntriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveCalculationParameterEntriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(CalculationParameterEntryParamFromJSON)),
    };
}

export function SaveCalculationParameterEntriesRequestToJSON(json: any): SaveCalculationParameterEntriesRequest {
    return SaveCalculationParameterEntriesRequestToJSONTyped(json, false);
}

export function SaveCalculationParameterEntriesRequestToJSONTyped(value?: SaveCalculationParameterEntriesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entries': ((value['entries'] as Array<any>).map(CalculationParameterEntryParamToJSON)),
    };
}

